import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';
import Header from './component/Header/Header';
import {
  BrowserRouter as Router,
  Switch,
  Route
} from "react-router-dom";
import Instructors from './component/Instructors/Instructors'
import Courses from './component/Courses/Courses'
import About from './component/About/About'
import Home from './component/HomePage/Home';
import NotFound from './component/NotFound/NotFound';
import {NavLink} from 'react-router-dom'
import Footer from './component/Footer/Footer';
import Details from './component/Details/Details';

function App() {
  const [tst,setTst] = useState([]);
  useEffect(()=>{
    fetch('information.json')
    .then(res=>res.json())
    .then(data=>setTst(data));
  },[])
  return (
    <div className>
      <Router>
        <Header></Header>
        <Switch>
          <Route exact path="/home">
              <Home></Home>
          </Route>
          <Route exact path="/">
              <Home></Home>
          </Route>
          
          <Route exact path="/about">
              <About></About>
          </Route>
          
          <Route exact path="/courses">
              <Courses></Courses>
          </Route>
          <Route exact path="/instructors">
            <Instructors></Instructors>
          </Route>
          <Route exact path="/details/:id">
            <Details></Details>
          </Route>
          <Route>
              <NotFound></NotFound>
          </Route>
        </Switch>
      </Router>
      <Footer></Footer>
    </div>
  );
}

export default App;
